import { render, staticRenderFns } from "./stateMx.vue?vue&type=template&id=318863fe&scoped=true"
import script from "./stateMx.vue?vue&type=script&lang=js"
export * from "./stateMx.vue?vue&type=script&lang=js"
import style0 from "./stateMx.vue?vue&type=style&index=0&id=318863fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318863fe",
  null
  
)

export default component.exports